import { useLanguage } from "@/context/LanguageContext";

export const TickerMarquee = () => {
  const { t } = useLanguage();

  return (
    <div className="relative bg-black py-5 overflow-hidden border-y-2 border-black" data-testid="ticker-marquee">
      <div className="flex whitespace-nowrap animate-[marquee_40s_linear_infinite]">
        {[0, 1].map((k) => (
          <span key={k} className="font-['Cutive'] text-2xl sm:text-3xl text-[#FFE440] mx-6 tracking-wide">
            {t.marquee}
            {t.marquee}
          </span>
        ))}
      </div>
    </div>
  );
};
